import { Navigate } from 'react-router-dom';

export function AdminProtectedRoute({ children }) {
  const token = localStorage.getItem('pecash_token');
  const isAdmin = localStorage.getItem('pecash_admin') === 'true';

  if (!token || !isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
